<script>
import useValidation from "@/use/Validation";
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";
import useTools from "@/use/Tools";
import {useEvaluationGravityStore} from "@/stores/Evaluation/EvaluationGravity";
import {computed, onMounted, ref} from "vue";
import axios from "axios";

export default {
    props: {
        addAction: Boolean,
        updateAction: Boolean,
        viewAction: Boolean,
        deleteAction: Boolean,
        type: String,
    },
    setup(props) {
        const readonly = computed(() => props.viewAction || props.deleteAction);

        const {mxRules} = useValidation();

        const {dialog, loading, overlay} = useSharedData();

        const {getBack} = useSharedMethod();

        const {$refs, $route} = useTools();

        const evaluationGravityStore = useEvaluationGravityStore();

        const evaluationGravity = ref({});

        function findById(id) {
            loading.value = true;
            axios.get(`/evaluationGravities/${id}`).then((response) => {
                evaluationGravity.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }


        function save() {
            if ($refs.form.validate()) {
                loading.value = true;
                evaluationGravity.value.type = props.type;
                axios.post('/evaluationGravities', evaluationGravity.value).then((response) => {
                    evaluationGravityStore.addEvaluationGravity(response.data);
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        function update() {
            if ($refs.form.validate()) {
                loading.value = true;
                evaluationGravity.value.type = props.type;
                axios.put('/evaluationGravities', evaluationGravity.value).then((response) => {
                    evaluationGravityStore.updateEvaluationGravity(response.data);
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        function remove() {
            if ($refs.form.validate()) {
                loading.value = true;
                axios.delete(`/evaluationGravities/${evaluationGravity.value.id}`).then(() => {
                    evaluationGravityStore.deleteEvaluationGravity(evaluationGravity.value);
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        onMounted(() => {
            if (!props.addAction)
                findById($route.params.id);
        });

        return {
            evaluationGravityStore,
            mxRules,
            readonly,
            dialog,
            loading,
            overlay,
            evaluationGravity,
            save,
            update,
            remove,
            getBack,
        };
    }
}
</script>

<template>
    <v-dialog
        v-model="dialog"
        max-width="800"
        persistent
        scrollable
    >
        <v-card>
            <w-dialog-toolbar
                :view-action="viewAction"
                :delete-action="deleteAction"
                :add-action="addAction"
                :update-action="updateAction"
            ></w-dialog-toolbar>
            <w-overlay
                :overlay="overlay"
                :loading="loading"
                :delete-action="deleteAction"
                @remove="remove"
                @cancel="overlay = false"
            ></w-overlay>
            <v-card-text>
                <v-container grid-list-md>
                    <v-form ref="form">
                        <w-fieldset :title="$t('common.general')">
                            <v-row dense>
                                <v-col cols="12">
                                    <w-label :label="$t('common.label')" required/>
                                    <w-text-field
                                        v-model="evaluationGravity.name"
                                        :readonly="readonly"
                                        :rules="[mxRules.required]"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <w-label :label="$t('common.note')" required/>
                                    <w-text-field
                                        v-model="evaluationGravity.note"
                                        :readonly="readonly"
                                        type="number"
                                        :rules="[mxRules.required]"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <w-label :label="$t('common.comment')"/>
                                    <w-simple-text-area
                                        v-model="evaluationGravity.description"
                                        :readonly="readonly"
                                    />
                                </v-col>
                            </v-row>
                        </w-fieldset>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn-add
                    :show="addAction"
                    :loading="loading"
                    @press="save(false)"
                />
                <w-btn-update
                    :show="updateAction"
                    :loading="loading"
                    @press="update"
                />
                <w-btn-delete
                    :show="deleteAction"
                    :loading="loading"
                    @press="overlay = true"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>